import Vue from 'vue'

const isServer = Vue.prototype.$isServer
const SPECIAL_CHARS_REGEXP = /([\:\-\_]+(.))/g
const MOZ_HACK_REGEXP = /^moz([A-Z])/
const ieVersion = isServer ? 0 : Number(document.documentMode)

function camelCase (name) {
  return name.replace(SPECIAL_CHARS_REGEXP, function (_, separator, letter, offset) {
    return offset ? letter.toUpperCase() : letter
  }).replace(MOZ_HACK_REGEXP, 'Moz$1')
}

let vendor = (() => {
  /* istanbul ignore if */
  if (isServer) {
    return false
  }
  let elementStyle = document.createElement('div').style
  let transformNames = {
    standard: 'transform',
    webkit: 'webkitTransform',
    Moz: 'MozTransform',
    O: 'OTransform',
    ms: 'msTransform'
  }

  for (let key in transformNames) {
    if (elementStyle[transformNames[key]] !== undefined) {
      return key
    }
  }
  return false
})()

var scrollBarWidth = null

const dom = {
  on: function (el, event, handler) {
    if (!isServer && document.addEventListener) {
      return (function (el, event, handler) {
        if (el && event && handler) el.addEventListener(event, handler, false)
      }(el, event, handler))
    } else {
      // IE 6 thru 10
      return (function (el, event, handler) {
        if (el && event && handler) el.attachEvent('on' + event, handler)
      }(el, event, handler))
    }
  },
  off: function (el, event, handler) {
    if (!isServer && document.removeEventListener) {
      return (function (el, event, handler) {
        if (el && event && handler) el.removeEventListener(event, handler, false)
      }(el, event, handler))
    } else {
      // IE 6 thru 10
      return (function (el, event, handler) {
        if (el && event && handler) el.detachEvent('on' + event, handler)
      }(el, event, handler))
    }
  },
  hasClass: function (el, cls) {
    if (!el || !cls) return false
    if (!cls) throw new Error('className cannot be empty.')
    if (el.classList) return el.classList.contains(cls)
    return (' ' + el.className + ' ').indexOf(' ' + cls + ' ') > -1
  },
  addClass: function (el, cls) {
    if (!el || !cls) return
    if (!cls) throw new Error('className cannot be empty.')
    var curClass = el.className
    var classes = cls.split(' ')
    for (var i = 0; i < classes.length; ++i) {
      var clsName = classes[i]
      if (!clsName) continue
      if (!this.hasClass(el, clsName)) {
        if (el.classList) el.classList.add(clsName)
        else {
          if (!curClass) curClass += clsName // className is empty
          else curClass += ' ' + clsName
        }
      } else continue
    }
    if (!el.classList) el.className = curClass
  },
  removeClass: function (el, cls) {
    if (!el || !cls) return
    if (!cls) throw new Error('className cannot be empty.')
    var curClass = el.className
    var classes = cls.split(' ')
    for (var i = 0; i < classes.length; ++i) {
      var clsName = classes[i]
      if (this.hasClass(el, clsName)) {
        if (el.classList) el.classList.remove(clsName)
        else {
          if (curClass.indexOf(' ' + clsName + ' ') > -1) curClass = curClass.replace(new RegExp(' ' + clsName + ' '), ' ')
          else if ((curClass.indexOf(' ' + clsName) > -1)) curClass = curClass.replace(new RegExp(' ' + clsName), '')
          else if ((curClass.indexOf(clsName + ' ') > -1)) curClass = curClass.replace(new RegExp(clsName + ' '), '')
          else curClass = curClass.replace(new RegExp(clsName), '')
        }
      }
    }
    if (!el.classList) el.className = curClass
  },
  getScreenRect: function () {
    // Opera incompatible screenLeft
    var leftPos = (typeof window.screenLeft === 'number') ? window.screenLeft : window.screenX
    var topPos = (typeof window.screenTop === 'number') ? window.screenTop : window.screenY
    return {
      left: leftPos,
      top: topPos
    }
  },
  getScrollBarWidth () {
    /* 获取滚动条宽度 */
    if (isServer) return 0
    if (scrollBarWidth !== null) return scrollBarWidth
    const outer = document.createElement('div')
    outer.className = 'v-scrollbar-container'
    outer.style.visibility = 'hidden'
    outer.style.width = '100px'
    outer.style.position = 'absolute'
    outer.style.top = '-99999px'
    document.body.appendChild(outer)
    const widthNoScroll = outer.offsetWidth // 可视宽度
    outer.style.overflow = 'scroll'
    const inner = document.createElement('div')
    inner.style.width = '100%'
    outer.appendChild(inner)
    const widthWithScroll = inner.offsetWidth
    outer.parentNode.removeChild(outer)
    scrollBarWidth = widthNoScroll - widthWithScroll
    return scrollBarWidth
  },
  nextTick (callback, params) {
    if (!callback) return
    setTimeout(() => {
      typeof callback === 'function' && callback(params)
    }, 20)
  },
  getDomSkipText (dom) {
    if (dom.nodeType === 3) {
      dom = dom.nextElementSibling || dom.nextSibling
      this.getDomSkipText(dom)
    }
    return dom
  },
  offset (el) {
    if (!el) throw new Error('element cannot be null.')
    let rect = el.getBoundingClientRect()
    return {
      top: rect.top + window.pageYOffset,
      left: rect.left + window.pageXOffset
    }
  },
  scrollTo (y = 0, x = 0) {
    window.scrollTo({
      behavior: 'smooth',
      left: x,
      top: y
    })
  },
  createTransformStyle (style) {
    if (!style) return
    return `
      transform: ${style};
      -ms-transform: ${style};
      -moz-transform: ${style};
      -webkit-transform: ${style};
      -o-transform: ${style};
    `
  },
  createTransformStyleObj (style) {
    if (!style) return
    return {
      'transform': style,
      '-ms-transform': style,
      '-moz-transform': style,
      '-webkit-transform': style,
      '-o-transform': style
    }
  }
}

export function prefixStyle (style) {
  /* istanbul ignore if */
  if (vendor === false) {
    return false
  }
  if (vendor === 'standard') {
    if (style === 'transitionEnd') {
      return 'transitionend'
    }
    return style
  }
  return vendor + style.charAt(0).toUpperCase() + style.substr(1)
}

export function getScrollTop (element) {
  if (element === window) {
    return Math.max(window.pageYOffset || 0, document.documentElement.scrollTop)
  } else {
    return element.scrollTop
  }
}

export function getScrollEventTarget (element) {
  let currentNode = element
  while (currentNode && currentNode.tagName !== 'HTML' && currentNode.nodeType === 1) {
    const overflowY = window.getComputedStyle(currentNode).overflowY
    if (overflowY === 'scroll' || overflowY === 'auto') {
      return currentNode
    }
    currentNode = currentNode.parentNode
  }
  return window
}

export function transitionEnd (el, fun) {
  const arr = ['msTransitionEnd', 'mozTransitionEnd', 'oTransitionEnd', 'webkitTransitionEnd', 'transitionend']
  const handler = {
    handleEvent (event) {
      arr.forEach(function (eventName) {
        el.removeEventListener(eventName, handler, false)
      })
      fun.apply(el, arguments)
    }
  }
  arr.forEach(function (eventName) {
    el.addEventListener(eventName, handler, false)
  })
}

export let supportsPassive = false
if (!isServer) {
  try {
    const opts = {}
    Object.defineProperty(opts, 'passive', {
      get () {
        /* istanbul ignore next */
        supportsPassive = true
      }
    })
    window.addEventListener('test-passive', null, opts)
  } catch (e) {}
}

export function on (target, event, handler, passive = false) {
  !isServer &&
    target.addEventListener(
      event,
      handler,
      supportsPassive ? { capture: false, passive } : false
    )
}

export function off (target, event, handler) {
  !isServer && target.removeEventListener(event, handler)
}

export const getStyle = ieVersion < 9 ? function (element, styleName) {
  if (isServer) return
  if (!element || !styleName) return null
  styleName = camelCase(styleName)
  if (styleName === 'float') {
    styleName = 'styleFloat'
  }
  try {
    switch (styleName) {
      case 'opacity':
        try {
          return element.filters.item('alpha').opacity / 100
        } catch (e) {
          return 1.0
        }
      default:
        return (element.style[styleName] || element.currentStyle ? element.currentStyle[styleName] : null)
    }
  } catch (e) {
    return element.style[styleName]
  }
} : function (element, styleName) {
  if (isServer) return
  if (!element || !styleName) return null
  styleName = camelCase(styleName)
  if (styleName === 'float') {
    styleName = 'cssFloat'
  }
  try {
    var computed = document.defaultView.getComputedStyle(element, '')
    return element.style[styleName] || computed ? computed[styleName] : null
  } catch (e) {
    return element.style[styleName]
  }
}

export default dom



// WEBPACK FOOTER //
// ./src/utils/dom.js